import React from "react"

// Using FA icons — no broken external image URLs
const stats = [
  { faIcon: "fa fa-user-graduate", data: "1,200+", title: "GRADUATES TRAINED" },
  { faIcon: "fa fa-user-tie",      data: "5+",     title: "EXPERT MENTORS" },
  { faIcon: "fa fa-book-open",     data: "4",       title: "TRAINING PROGRAMMES" },
  { faIcon: "fa fa-calendar-alt",  data: "10+",     title: "YEARS EXPERIENCE" },
]

const Awrapper = () => {
  return (
    <section className="awrapper">
      <div className="container">
        <div className="awrapper-grid">
          {stats.map((s, i) => (
            <div className="awrapper-box" key={i}>
              <div className="awrapper-icon">
                <i className={s.faIcon}></i>
              </div>
              <div className="awrapper-text">
                <h1>{s.data}</h1>
                <h3>{s.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Awrapper
